import type { GetProfileByUsername200Preferences } from './getProfileByUsername200Preferences';
import type { GetProfileByUsername200SocialLinks } from './getProfileByUsername200SocialLinks';

export type GetProfileByUsername200 = {
  /** 자기소개 */
  bio?: string;
  /** 커버 이미지 URL */
  coverImageUrl?: string;
  createdAt?: string;
  /** 전체 이름 */
  fullName?: string;
  /** 위치 */
  location?: string;
  preferences?: GetProfileByUsername200Preferences;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
  socialLinks?: GetProfileByUsername200SocialLinks;
  updatedAt?: string;
  /** 사용자 ID */
  userId?: string;
  /** 사용자명 */
  username?: string;
  /** 웹사이트 */
  website?: string;
};
